import { useState } from "react";
import { Modal } from "./Common/Modal";
import AddressSearch from "./AddressSearch";

const CheckAvailabilityModal = () => {
  // export default function CheckAvailabilityModal() {
  const [isPopUp, setIsPopUp] = useState(false);
  const onClose = () => {
    setIsPopUp(false);
    window.parent.postMessage('closeCAPopupIframe', '*');
  };
  const handleCALClick = () => {
    setIsPopUp(true);
  };
  return (
    <div className="twp">
      <div className="pl-3">
        <button
          className="block w-full border-none flex-shrink-0 h-[3.25rem] font-bold text-white bg-gradient-to-r from-[#0098b8] to-[#007c83] disabled:bg-[#cac9c8] py-2 px-3 text-sm"
          type="button"
          onClick={handleCALClick}>
          Check Availability
        </button>
      </div>
      <Modal
        isOpen={isPopUp}
        onRequestClose={onClose}
        size="sm"
        className="pb-3 pt-8"
      >
        <div className="twp">
        <AddressSearch></AddressSearch>
        </div>
      </Modal>
    </div>
  )
}
export default CheckAvailabilityModal;